import { Component } from "react";
import withAuth from "../../../components/withAuth";
import { withStyles } from "@mui/styles";
import { compose } from "redux";
import { connect } from "react-redux";
import { getDefaultRisk } from "../../../redux/analyseRisques/analyseRisquesActions";
import RisqueCard from "../../../components/AnalyseRisques/RisqueCard";

const styles = (theme) => ({
	row: {
		"&:nth-of-type(odd)": {
			backgroundColor: theme.palette.background.default,
		},
	},
});

class AnalyseRisquesDetails extends Component {
	render() {
		let riskCards = [];
		let index = 0;

		this.props.currentRisks.forEach((d) => {
			riskCards.push(
				<RisqueCard key={index} currentRisk={d} currentRiskRowIndex={index} />
			);
			index++;
		});

		riskCards.push(
			<RisqueCard
				key={index}
				currentRisk={getDefaultRisk(
					0,
					0,
					this.props.participants,
					this.props.activeUser
				)}
				currentRiskRowIndex={index}
			/>
		);

		return (
			<div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
				{riskCards}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		header: state.analyseRisques.header,
		currentRisks: state.analyseRisques.risks,
		riskTypes: state.riskTypes.types,
		instructionTypes: state.solutionTypes.types,
		participants: state.analyseRisques.participants,
	};
};

const mapDispatchToProps = () => {
	return {};
};

export default compose(
	withAuth,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(AnalyseRisquesDetails);
